export const SHARE_TYPE = {
    TICKET: 'ticket',
    BET_STATS: 'bet-stats',
} as const;
